import script from "./CommissionRange.vue?vue&type=script&setup=true&lang=js"
export * from "./CommissionRange.vue?vue&type=script&setup=true&lang=js"

import "./CommissionRange.vue?vue&type=style&index=0&id=1061c0c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1061c0c8"]])

export default __exports__